<template>
  <a-row :gutter="24">
    <a-col class="afloat-lg-left">
      <div class="gallery-panel">
        <template v-if="windowWidth < 768">
          <T1GallerySlider :images="images" />
        </template>
        <template v-else>
          <T1GalleryTiles :images="images" :objectName="locidname" />
        </template>
        <div class="lead offer-content">
          <div class="lead__text lead--text" itemprop="description"></div>
          <div class="lead__browse-action" v-if="topOffersExists">
            <a
              :href="getOfertyUrl()"
              class="btn btn-lg btn-green"
              :title="
                locidname + ' - wakacje już od ' + cheapestOfferPrice + ' zł'
              "
              >{{ locidname }} - wakacje już&nbsp;od&nbsp;<strong
                >{{ cheapestOfferPrice }}&nbsp;zł</strong
              ></a
            >
          </div>
        </div>
      </div>
    </a-col>
  </a-row>
</template>

<script>
import axios from "axios";
import * as CONFIG from "./config.js";
import T1GallerySlider from "./T1Gallery/T1GallerySlider";
import T1GalleryTiles from "./T1Gallery/T1GalleryTiles";

axios.defaults.withCredentials = false;

export default {
  props: {
    clocid: String,
    locidname: String,
    geolocid: String,
    cheapestOfferPrice: String,
    topOffersExists: Boolean
  },
  data: () => ({
    url: "/getgeoopis.json",
    dparams: "",
    setImages: [],
    images: [],
    opisy: [],
    name: "",
    windowWidth: window.innerWidth
  }),
  methods: {
    getImages() {
      let that = this;
      for (let i = 0; i < 9; i++) {
        this.setImages[i] = {
          txt: that.getImageUrl() + "-000" + (i + 1) + ".jpg",
          name: "Zdjęcie nr " + i
        };
      }
    },
    getGeoOpisy() {
      var pars = this.dparams;
      return axios
        .get(CONFIG.API_URL + this.url + "?" + pars, null, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Accept: "application/json"
          }
        })
        .then(response => {
          /*alert("DATA:" + response.data);
               alert("STATUS:" + response.status);
               alert("DATA ITEMS:" + JSON.stringify(response.data));*/
          return response.data;
        })
        .catch(e => {
          alert("ERROR" + e);
        });
    },
    getImageUrl() {
      return (
        "https://www." + CONFIG.serwis + "/photo/" + this.clocid + this.images
      );
    },
    getOfertyUrl() {
      return "/oferta/szukaj.xml?locid=" + this.geolocid;
    }
  },
  mounted() {
    this.getImages();
    this.images = this.setImages;

    window.onresize = () => {
      this.windowWidth = window.innerWidth;
    };
  },
  components: {
    T1GallerySlider,
    T1GalleryTiles
  }
};
</script>

<style lang="scss" scoped>
.gallery-panel {
  margin: 0 -16px;

  @media (min-width: $screen-sm) {
    margin: 0 0 24px;
  }
}

.lead {
  @media (max-width: $screen-xs-max) {
    padding: 8px 16px 0;
  }

  padding: 24px 0 0;

  &__browse-action {
    border-top: 1px solid $gray-default;
    margin-bottom: 12px;
    margin-top: 18px;
    padding-top: 22px;
    text-align: center;

    > a {
      white-space: normal;
    }
  }
}
</style>
